import { render, staticRenderFns } from "./WelcomeCobrandingActivity.vue?vue&type=template&id=cf7c3c22&scoped=true&"
import script from "./WelcomeCobrandingActivity.vue?vue&type=script&lang=js&"
export * from "./WelcomeCobrandingActivity.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/style/base.css?vue&type=style&index=0&id=cf7c3c22&scoped=true&lang=css&"
import style1 from "./WelcomeCobrandingActivity.vue?vue&type=style&index=1&id=cf7c3c22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7c3c22",
  null
  
)

export default component.exports